function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M23.611 62.508c-4.253-2.836-7.23-6.604-8.611-10.896L16.904 51c1.24 3.857 3.944 7.261 7.817 9.844l-1.11 1.664M40.255 68.011c-2.825 0-5.603-.363-8.255-1.08l.522-1.93c4.968 1.342 10.509 1.34 15.472-.001l.522 1.93a31.68 31.68 0 01-8.261 1.081M57.07 63.058l-1.11-1.664c5.437-3.625 8.555-8.923 8.555-14.535 0-5.991-3.468-11.511-9.515-15.145L56.03 30c6.664 4.005 10.485 10.15 10.485 16.859 0 6.292-3.442 12.196-9.445 16.199",
  fill: "#A5ACB0"
}), React.createElement("path", {
  d: "M19 52.943h-8c-1.654 0-3-1.346-3-3v-6c0-1.654 1.346-3 3-3h3.296c1.081-2.761 3.332-5.604 6.704-8.466V22l8.14 5.814c2.585-1.015 4.86-1.871 7.86-1.871v2c-2.723 0-4.783.81-7.393 1.836l-.747.293L23 25.886v7.527l-.361.3c-3.516 2.916-5.827 5.868-6.687 8.537l-.223.693H11c-.552 0-1 .449-1 1v6c0 .551.448 1 1 1h8v2M33 72H23V58h2v12h6v-7h2v9M57 72H47v-9h2v7h6V58h2v14",
  fill: "#A5ACB0"
}), React.createElement("path", {
  d: "M26 45c-2.757 0-5-2.243-5-5h2c0 1.654 1.346 3 3 3s3-1.346 3-3h2c0 2.757-2.243 5-5 5M65 48v-2c2.757 0 5-2.243 5-5h2c0 3.86-3.141 7-7 7",
  fill: "#A5ACB0"
}), React.createElement("path", {
  d: "M49.601 32.8l-1.202-1.6A3.966 3.966 0 0050 28c0-2.206-1.794-4-4-4s-4 1.794-4 4c0 .875.277 1.705.801 2.402l-1.598 1.202A5.948 5.948 0 0140 28c0-3.309 2.691-6 6-6s6 2.691 6 6a5.956 5.956 0 01-2.399 4.8M47 14h2V8h-2z",
  fill: "#EA7125"
}), React.createElement("path", {
  d: "M52.4 35.8C48.99 33.243 44.28 32 38 32v-2c6.729 0 11.832 1.374 15.6 4.2l-1.2 1.6",
  fill: "#A5ACB0"
}), React.createElement("path", {
  fill: "#EA7125",
  d: "M43 20h2v-6h-2zM47 18h2v-2h-2zM43 12h2v-2h-2z"
}), React.createElement("path", {
  fill: "#A5ACB0",
  d: "M39 60h2v-2h-2zM43 60h2v-2h-2zM35 60h2v-2h-2zM8 72h64v-2H8z"
}), React.createElement("path", {
  d: "M0 0h80v80H0z"
}));

var SvgIconIllustrationPiggyBank = function SvgIconIllustrationPiggyBank(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80"
  }, props), _ref);
};

export default SvgIconIllustrationPiggyBank;